module.exports = __webpack_public_path__ + "media/images/illustrations/prepworks-path-to-success-ab2bb4defe181a2935a92d288cf8db69.svg";